<template>
  <div>
    <span class="text-h5">{{ $t('PROFILE.RELATIONS_WITH_COMPANIES') }}</span>

    <v-data-table
      v-if="!!relations"
      :headers="headers"
      :items="relations"
      hide-default-footer
    >
      <!--            <template slot="no-data">-->
      <!--                <tr style="visibility: hidden;" />-->
      <!--            </template>-->

      <template v-slot:item.key="{ item }">
        <v-checkbox v-model="item.key" disabled></v-checkbox>
      </template>

      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-menu transition="scale-transition" origin="center center">
            <template v-slot:activator="{ on }">
              <v-btn text icon x-small v-on="on">
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="$emit('edit', item)">
                <v-list-item-title>
                  <v-icon class="mr-1" small>mdi-account-edit</v-icon>
                  {{ $t('ITEM.EDIT') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('delete', item)">
                <v-list-item-title>
                  <v-icon class="mr-1" small>mdi-delete</v-icon>
                  {{ $t('ITEM.DELETE') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'RelatedCompanies',

  props: {
    relations: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    relation: null
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('PROFILE.NAME'),
          value: 'company.name',
          sortable: false,
          align: 'left',
          width: 200
        },
        {
          text: this.$t('RELATIONS.RELATIONSHIP'),
          value: 'relationship.name',
          sortable: false,
          width: 200
        },
        {
          text: this.$t('RELATIONS.PRIORITY'),
          value: 'priority',
          sortable: false,
          width: 20
        },
        {
          text: this.$t('RELATIONS.KEY'),
          value: 'key',
          sortable: false,
          width: 20
        },
        {
          text: this.$t('RELATIONS.NOTES'),
          value: 'notes',
          sortable: false,
          width: 100
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          width: 20,
          align: 'center'
        }
      ];
    }
  }
};
</script>
